import React from "react";
import {isBrowser, isMobile} from 'react-device-detect';
import PharmacyOrderPrepareOrderActions from "../ActionsComponents/PharmacyOrderPrepareOrderActions";
import PharmacyVendorAssignedActions from "../ActionsComponents/PharmacyVendorAssignedActions";
import PharmacyVendorAssignedActionsMobile from "../ActionsComponents/PharmacyVendorAssignedActionsMobile";
import PharmacyWaitingForPaymentActions from "../ActionsComponents/PharmacyWaitingForPaymentActions";

const PharmacyOrderActions = (props) => {
    const { order } = props;
    const renderActions = () => {
        if (isBrowser){
            switch (order.drug_store_status) {
                case "vendor_assigned":
                    return <PharmacyVendorAssignedActions {...order} />
                case "prepare_prescription":
                    return <PharmacyOrderPrepareOrderActions {...order} />
                case "waiting_for_payment":
                    return <PharmacyWaitingForPaymentActions {...order} />
                default:
                    break;
            }
        }else if(isMobile){
            switch (order.drug_store_status) {
                case "vendor_assigned":
                    return <PharmacyVendorAssignedActionsMobile {...order} />
                case "prepare_prescription":
                    return <PharmacyOrderPrepareOrderActions {...order} />
                case "waiting_for_payment":
                    return <PharmacyWaitingForPaymentActions {...order} />
                default:
                    break;
            }
        }

    };
    return (
        <>
            {renderActions()}
        </>
    );
};

export default PharmacyOrderActions;
